import { useFormContext } from "src/lib/templates";
import { RecoveryInitialValue } from "../initialValues";

export const useRecoveryFormContext = () => useFormContext<RecoveryInitialValue>();
